<template>

    <div class="col-md-6 col-sm-6 col-xs-6">
        <base-button :disabled="isLoading" @click="copyToClipboard()"
                     class="btn-dark float-sm-none float-md-left more-margin-top">Copy</base-button>
        <!-- Extending Excel export to allow for custom retrieval methods (from outside this component). By Default, export to excel will use previously developed method until a complete refactor is completed.  -->
        <base-button v-if="isUsingCustomExcel" :disabled="isLoading" @click="excelExportCustom()"
                     class="btn-dark float-sm-none float-md-left more-margin-top">Excel</base-button>
        <base-button v-else :disabled="isLoading" @click="exportToExcel()"
                     class="btn-dark float-sm-none float-md-left more-margin-top">Excel</base-button>

        <base-button :disabled="isLoading" @click="exportToCsv()"
                     class="btn-dark float-sm-none float-md-left more-margin-top">CSV</base-button>

        <base-button :disabled="isLoading" @click="exportToPdf()"
                     class="btn-dark float-sm-none float-md-left more-margin-top">PDF</base-button>
    </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton } from "@/components";
import axios from "@/axios";
import Util from "@/util/util";

export default {
    components: {
        BaseButton
    },
    name: "export-group",
    props: {
        name: {
            type: String,
            default: "",
        },
        excelUrl: {
            type: String,
            default: "",
        },
        getData: {
            type: Function
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        excelExportCustom: {
            type:Function
        },
        isUsingCustomExcel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rows: [],
        }
    },
    methods: {
        async copyToClipboard() {
            this.$emit("loading", true);
            this.rows =  await this.getData();
            Util.copyTableToClipboard(this.rows);
            this.$emit("loading", false);
        },
        async exportToExcel() {
            this.$emit("loading", true);
            this.rows =  await this.getData();
            try {
                let res = await axios({
                    url: this.excelUrl,
                    method: "POST",
                    data: this.rows,
                    responseType: "blob",
                    config: { showToast: false },
                });
                Util.fileDownload(res.data, `${this.name}.xlsx`);
                this.$emit("loading", false);
            } catch (err) {
                this.$toast.error(
                    "Error on exporting to the excel, Please try again later"
                );
                this.$emit("loading", false);
            }
        },
        async exportToCsv() {
            this.$emit("loading", true);
            this.rows =  await this.getData();

            Util.exportToCsv(`${this.name}.csv`, this.rows);
            this.$emit("loading", false);
        },
        async exportToPdf() {
            this.$emit("loading", true);
            this.rows =  await this.getData();

            Util.exportToPdf(`${this.name}.pdf`, this.rows);
            this.$emit("loading", false);
        }
    }
};
</script>
<style>

</style>
